// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck-editor__editable{min-height:300px}.ck.ck-editor__editable>.ck-placeholder:before{color:#b1b7ba;white-space:break-spaces}", ""]);
// Exports
module.exports = exports;
